export default "__VITE_ASSET__BJ5dpX8L__"